var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncliAlsa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 44,
    viewBox: "0 0 38 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_1927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 11.5L29.3621 7.07064C32.5 4.04941 31.3567 12.0278 32.1046 14.6237C32.7646 16.9116 38.0298 21.2235 38.0004 22.8807C38.0004 23.2181 37.7658 23.6874 37.4725 23.878L35.6392 23.7314L20.3277 4.78272L19.1984 4.04941L17.7318 4.78272L2.43501 23.7314C1.15906 24.8167 -0.850207 23.3941 0.396416 21.8834L18.5678 0.0895465C19.1398 -0.101113 19.5211 0.0602142 19.9757 0.38287C21.2957 1.2775 24.5809 6.45466 26.1795 8.11193C26.8542 8.80124 29 11.5 29 11.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8929 24.6208C9.03416 25.9554 4.00367 39.9616 11.1314 40.7095C14.534 41.0762 23.5683 41.1055 26.9269 40.7095C33.5413 39.9176 29.5961 29.7833 30.8427 25.5741C31.312 24.0048 33.3506 24.1808 33.6733 26.2634C33.9226 27.8767 33.5706 36.1777 33.3066 37.9376C32.8813 40.8122 30.0508 42.9828 27.2789 43.2614C23.3337 43.6574 14.3433 43.6868 10.4274 43.2614C7.96353 42.9975 5.77828 41.1055 5.0303 38.7589C4.28233 36.4124 3.95967 28.258 4.45832 25.9407C4.69298 24.8261 5.9396 24.0341 6.8929 24.6208Z",
    fill: "#878787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_1927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 43.5731,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncliAlsa);
export default __webpack_public_path__ + "static/media/incli_alsa.f46e0b391ec6b171ab7696d4348ced7b.svg";
export { ForwardRef as ReactComponent };